/* eslint-disable @typescript-eslint/no-unused-vars */ // @TODO look into why this state is being set, but not used
import React from "react";
import { useEffect, useState } from "react";
import { IAddress, ICSIDUserStatus } from "../../store/csid/types";
import * as services from "../../store/service";
import * as csidUtil from "../csid/csid";
import L3SecurityQuestionComponent from "../Credit/L3/L3SecurityQuestionComponent";
import L3SuccessComponent from "../Credit/L3/L3SuccessComponent";
import { DialogComponent } from "../common/DialogComponent";
import L3CallInComponent from "../Credit/L3/L3CallInComponent";
import L3ContinueComponent from "../Credit/L3/L3ContinueComponent";
import L3DisclosureComponent from "../Credit/L3/L3DisclosureComponent";
import L3SystemErrorComponent from "../Credit/L3/L3SystemErrorComponent";
import L3InvalidSsnComponent from "../Credit/L3/L3InvalidSsnComponent";
import L3NotEnoughInfoComponent from "../Credit/L3/L3NotEnoughInfoComponent";
import FullSSNComponent from "../csid/FullSSNComponent";
import FullSINComponent from "../csid/FullSINComponent";
import { useDispatch, useSelector } from "react-redux";
import * as MyAccountActions from "../../store/myAccount/actions";
import { useTranslation } from "react-i18next";
import { ApplicationState } from "../../store";

interface IProps {
    setL3Auth: any;
    alertDetails: any;
    creditAlertDetailsCallback: any;
    triggeredFrom: any;
}

const CreditAlert = ({ setL3Auth, creditAlertDetailsCallback, alertDetails, triggeredFrom }: IProps) => {
    const status = {
        success: "success",
        error: "error",
        // apiException: 'api-exception',
        apiStatus: "api-status",
        timeout: "timeout",
        attemptFail: "attempt-fail",
        systemError: "system-error",
        l3LastTryFail: "l3-last-try-fail",
        l3LastTryTimemout: "l3-timeout-locked",
        l3AttemptFail: "l3-attempt-fail",
        l3Timeout: "l3-timeout",
        thinClient: "thin-client",
        manualAuthentication: "manual-authentication",
        locked: "locked",
        l3OtpLocked : "l3-otp-locked",
        inProgress: "in-progress",
        invalidSsn: "invalid-ssn",
        noQuestion: "no-question",
        lockedNotEnoughInfo: "locked-not-enough-info",
    };

    const dispatch = useDispatch();
    const getAccountInformation = () => dispatch(MyAccountActions.actionCreators.getAccountInformation(true));

    const [isLoading, setIsLoading] = useState(false);
    const [isIDFuser, setIsIDFUser] = useState(false);
    const [isTuCanadianUser, setIsTuCanadianUser] = useState(false);
    const userCountry = useSelector((state: ApplicationState) =>
        state.myAccountServiceState?._unifiedAccountInfo?.country
    );
    const partnerId: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );
    const isCanadianUser = isTuCanadianUser || userCountry?.toUpperCase() === 'CA';
    const shouldUseSIN = partnerId === 2597 || isCanadianUser;
    const [isAutoEnrolledUserUser, setIsAutoEnrolledUserUser] = useState(false);
    const [showL3SecurityQuestionDialog, setShowL3SecurityQuestionDialog] = useState(false);
    const [showL3VerifiedDialog, setShowL3VerifiedDialog] = useState(false);
    const [showCallInComponent, setShowCallInComponent] = useState(false);
    const [callInReason, setCallInReason] = useState("manual-authentication");
    const [showInitialL3Continue, setShowInitialL3Continue] = useState(false);
    const [showDisclosureDiaglog, setShowDisclosureDiaglog] = useState(false);
    const [disclosureAgreed, setDisclosureAgreed] = useState(false);
    const [ssn, setSSN] = useState("0");
    const [dob, setDOB] = useState("");
    const [address, setAddress] = useState<IAddress>({
        address1: "",
        address2: "",
        city: "",
        state: "",
        zipCode: "",
    });
    const [l3SecurityQuestionTryCount, setL3SecurityQuestionTryCount] = useState(1);
    const [showL3ContinueDialogForError, setShowL3ContinueDialogForError] = useState(false);
    const [csidUserStatus, setCSIDUserStatus] = useState({} as ICSIDUserStatus);
    const [messageKeyForL3ContinueWithError, setMessageKeyForL3ContinueWithError] = useState("credit-service");
    const [showL3SystemError, setShowL3SystemError] = useState(false);

    const [showFullSSNDialog, setShowFullSSNDialog] = useState(false);
    const [isDobRequired, setIsDobRequired] = useState(false);
    const [isAddressRequired, setIsAddressRequired] = useState(false);
    const [invalidSsnAttemptStatus, setInvalidSsnAttemptStatus] = useState("");
    const [showL3InvalidSsnComponent, setShowL3InvalidSsnComponent] = useState(false);
    const [noQuestionAttemptStatus, setNoQuestionAttemptStatus] = useState("");
    const [showL3NotEnoughInfoComponent, setShowL3NotEnoughInfoComponent] = useState(false);

    const ensureDataFetched = () => {
        getUserCSIDStatus();
    };
    const { t: tLang } = useTranslation();

    useEffect(() => {
        ensureDataFetched();
    }, []);

    const getUserCSIDStatus = () => {
        setIsLoading(true);
        services
            .getUserCSIDStatus()
            .then((data) => {
                setIsLoading(false);
                const csidUserStatus: ICSIDUserStatus = data as ICSIDUserStatus;
                setIsIDFUser(csidUserStatus.isIDFUser);
                setCSIDUserStatus(csidUserStatus);
                  if (csidUserStatus?.l3AuthProvider?.isTU || csidUserStatus?.l3AuthProvider?.isIDF) {
                    if (
                        csidUserStatus["auth-status"] != null &&
                        (csidUserStatus["auth-status"].trim().toUpperCase() === "LOCKED" ||
                            csidUserStatus["auth-status"].trim().toUpperCase() === "LOCKED-NOT-ENOUGH-INFO" ||
                            csidUserStatus["auth-status"].trim().toUpperCase() === "L3-OTP-LOCKED"  )
                    ) {
                        if (csidUserStatus["auth-status"].trim().toUpperCase() === "LOCKED-NOT-ENOUGH-INFO") {
                            setCallInReason("locked-not-enough-info");
                        }
                        setShowCallInComponent(true);
                        if ( csidUserStatus["auth-status"].trim().toUpperCase() === "L3-OTP-LOCKED" ){
                           setCallInReason("l3-otp-locked");
                        }
                        // show call in component
                        setShowCallInComponent(true);
                    } else {
                        const dobStatus = csidUserStatus["dob-status"];
                        setIsDobRequired(dobStatus === "REQUIRED");

                        const addressStatus = csidUserStatus["address-status"];
                        setIsAddressRequired(addressStatus === "REQUIRED");

                        setShowDisclosureDiaglog(true);
                    }
                } else if (csidUserStatus?.l3AuthProvider?.isExperian) {
                    const nextStep: csidUtil.NEXT_STEP = csidUtil.getNextStep(csidUserStatus);
                    switch (nextStep) {
                        case csidUtil.NEXT_STEP.TRIGGER_L3_AUTHENTICATION:
                            setShowDisclosureDiaglog(true);
                            break;

                        default:
                            setShowDisclosureDiaglog(true);

                            break;
                    }
                }

                // for tu canadian user
                if (csidUserStatus.isTUUser) {
                    services.isTuCanadianUser().then((response) => {
                        if (response && response.hasError === false) {
                            setIsTuCanadianUser(response.isCanadiaUser);
                        }
                    });

                    services.IsAutoEnrolledUser().then((response) => {
                        if (response) {
                            setIsAutoEnrolledUserUser(response.isAutoEnrolledUser);
                        }
                    });
                }
            })
            .catch((error) => {
                setIsLoading(false);
                // TODO: need to check if any api error happens what to do next?
            });
    };

    // #region disclosure
    const closeDisclosureDialogCallBack = (callbackObj: any) => {
        setShowDisclosureDiaglog(false);
        setL3Auth(false);
        // if user close the disclosure dialog without agree, then in UI load "Verify my identity" component
        // setShowInitialL3Continue(true);
    };
    // Disclosure part
    const disclosureSubmitCallBack = (callbackObj: any) => {
        // close the disclosure dialog.
        setShowDisclosureDiaglog(false);
        // set the agree flag true for future use.
        setDisclosureAgreed(true);

        if (csidUserStatus?.l3AuthProvider?.isTU || csidUserStatus?.l3AuthProvider?.isIDF) {
            if (csidUserStatus.l3AuthProvider.isTU && csidUserStatus["ssn-status"] === "NOT_REQUIRED" && (isTuCanadianUser || isAutoEnrolledUserUser)) {
                setShowL3SecurityQuestionDialog(true);
            } else {
                setShowFullSSNDialog(true);
            }
        } else if (csidUserStatus?.l3AuthProvider?.isExperian) {
            const nextStep: csidUtil.NEXT_STEP = csidUtil.getNextStep(csidUserStatus);
            switch (nextStep) {
                case csidUtil.NEXT_STEP.TRIGGER_L3_AUTHENTICATION:
                    setShowL3SecurityQuestionDialog(true);
                    break;
                default:
                    setShowL3SecurityQuestionDialog(true);
                    break;
            }
        }
    };
    //#endregion
    // #region l3-security-question
    const closeL3SecurityQuestionDialogComponent = (callbackObj: any) => {
        setShowL3SecurityQuestionDialog(false);
        setL3Auth(false);
        // if user close the L3 Security Question Dialog with cancel / ESC / X, then in UI load "Verify my identity" component
        // setShowInitialL3Continue(true);
    };
    // #region l3-success
    const l3SuccessComponentContinueCallBack = (callbackObj: any) => {
        // Load the alert popup on success of the l3 auth flow
        setShowL3VerifiedDialog(false);
        creditAlertDetailsCallback(alertDetails);
    };

    const submitL3SecurityQuestionDialogComponent = (callbackObj: any) => {
        setShowL3SecurityQuestionDialog(false);
        if (callbackObj.status === status.success) {
            // l3 authentication success
            setIsLoading(true);
            setShowL3VerifiedDialog(true);
            services
                .updateL3AttemptReason("SUCCESS", "L3 successful")
                .then((data) => {
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.log({ error });
                    setIsLoading(false);
                });
        } else if (callbackObj.status === status.error) {
            let errorReason = callbackObj.data.reason;
            if (errorReason === status.l3AttemptFail) {
                setMessageKeyForL3ContinueWithError(errorReason);
                setShowL3ContinueDialogForError(true);
            } else if (errorReason === status.l3LastTryFail) {
                setCallInReason(errorReason);
                setShowCallInComponent(true);
            } else {
                setShowL3SystemError(true);
            }
        }
    };

    const submitL3SecurityQuestionDialogComponentForTu = (callbackObj: any) => {
        setShowL3SecurityQuestionDialog(false);
        if (callbackObj.status === status.success) {
            // l3 authentication success
            setShowL3VerifiedDialog(true);

            if (address && address.address1) {
                getAccountInformation();
            }
        } else if (callbackObj.status === status.locked) {
            setShowCallInComponent(true);
        } else if (callbackObj.status === status.l3OtpLocked) {
            setShowCallInComponent(true);
        } else if (callbackObj.status === status.l3LastTryTimemout)  {
            setShowCallInComponent(true);
        } else if (callbackObj.status === status.error) {
            setShowL3SystemError(true);
        } else if (callbackObj.status === status.inProgress) {
            setShowInitialL3Continue(true);
        }
    };

    const l3SecurityQuestionDialogTimeOut = (callbackObj: any) => {
        setShowL3SecurityQuestionDialog(false);
        setL3Auth(false);
        let errorReason = callbackObj.data.reason;
        if (errorReason === status.l3LastTryTimemout) {
            setCallInReason(errorReason);
            setShowCallInComponent(true);
        } else {
            setMessageKeyForL3ContinueWithError(errorReason);
            setShowL3ContinueDialogForError(true);
        }
    };
    const l3ContinueWithErrorSubmitCallBack = (callbackObj: any) => {
        setShowL3ContinueDialogForError(false);
        const tempTryCount = l3SecurityQuestionTryCount + 1;
        setL3SecurityQuestionTryCount(tempTryCount);
        setShowL3SecurityQuestionDialog(true);
    };

    const getL3QuestionErrorCallBack = (callbackObj: any) => {
        // close the dialog and show manual authentication to be on safe side
        setShowL3SecurityQuestionDialog(false);
        let errorReason = callbackObj.data.reason;
        if (errorReason === status.systemError) {
            setShowL3SystemError(true);
        }
        else {
            setCallInReason(errorReason);
            setShowCallInComponent(true);
        }
    };
    const getL3QuestionErrorCallBackForTu = (callbackObj: any) => {
        // close the dialog and show manual authentication to be on safe side
        setShowL3SecurityQuestionDialog(false);
        if (callbackObj.status === status.invalidSsn) {
            setInvalidSsnAttemptStatus(callbackObj.data.detail.providerResponse["auth-status"]);
            setShowL3InvalidSsnComponent(true);
        } else if (callbackObj.status === status.noQuestion || callbackObj.status === status.lockedNotEnoughInfo) {
            setNoQuestionAttemptStatus(callbackObj.data.detail.providerResponse["auth-status"]);
            setShowL3NotEnoughInfoComponent(true);
        } else if (callbackObj.status === status.locked) {
            setShowCallInComponent(true);
        }  else if (callbackObj.status === status.l3OtpLocked) {
                setShowCallInComponent(true);}
        else {
            setShowL3SystemError(true);
        }
    };
    const l3InvalidSsnRetryCallBack = () => {
        setShowL3InvalidSsnComponent(false);
        setShowFullSSNDialog(true);
    };

    const l3NotEnoughInfoCloseCallBack = (callbackObj: any) => {
        setShowL3NotEnoughInfoComponent(false);
        if ("locked-not-enough-info" === noQuestionAttemptStatus) {
            setCallInReason("locked-not-enough-info");
            setShowCallInComponent(true);
        } else {
            setShowInitialL3Continue(true);
        }
    };

    const l3NotEnoughInfoRetryCallBack = () => {
        setShowL3NotEnoughInfoComponent(false);
        setShowFullSSNDialog(true);
    };

    const l3InvalidSsnCloseCallBack = (callbackObj: any) => {
        setShowL3InvalidSsnComponent(false);
        if ("locked" === invalidSsnAttemptStatus) {
            setShowCallInComponent(true);
        } else {
            setShowInitialL3Continue(true);
        }
    };

    // #region fullSSN-dialog
    const closeFullSSNDialogComponent = (callbackObj: any) => {
        setShowFullSSNDialog(false);
        // if user close the Full SSN with cancel / ESC / X, then in UI load "Verify my identity" component
        setShowInitialL3Continue(true);
    };

    const submitFullSSNDialogComponent = (callbackObj: any) => {
        setShowFullSSNDialog(false);
        if (callbackObj.status === status.success) {
            setSSN(callbackObj.data.ssn);
            setDOB(callbackObj.data.dob);
            setAddress(callbackObj.data.address as IAddress);
            setShowL3SecurityQuestionDialog(true);
        }
    };
    // #endregion

    const callInContinueCallBack = () => {
        setShowCallInComponent(false);
        if (triggeredFrom === "Dashboard") {
            window.location.reload();
        }
    };

    const closeCallback = () => {
        setShowCallInComponent(false);
        if (triggeredFrom === "Dashboard") {
            window.location.reload();
        }
    };

    const l3SystemErrorRefreshCallBack = (callbackObj: any) => {
        setShowL3SystemError(false);
        // getCSIDUserStatusAndProceedToNext();
    };

    const l3SystemErrorCloseCallBack = (callbackObj: any) => {
        setShowL3SystemError(false);
        // setShowInitialL3Continue(true);
    };

    return (
        <>
            {(csidUserStatus?.l3AuthProvider?.isTU || csidUserStatus?.l3AuthProvider?.isIDF) && (
                <React.Fragment>
                    {showFullSSNDialog && (
                        <DialogComponent dialogId="dialog-full-ssn" title="Full SSN" closeDialog={closeFullSSNDialogComponent} hideCloseButton={true}>
                            {shouldUseSIN
                                ?
                                <FullSINComponent
                                    closeButtonText={"Cancel"}
                                    onCloseCallback={closeFullSSNDialogComponent}
                                    openAsDialog={true}
                                    submitButtonText={"Submit"}
                                    onSubmitCallback={submitFullSSNDialogComponent}
                                    displaySSNInputNumber={false}
                                    dobRequired={isDobRequired}
                                    csidUserStatus={csidUserStatus}
                                    dispalyAdditionalHeaderMessage={false}
                                    ignoreCSIDSubmission={true}
                                />
                                :
                                <FullSSNComponent
                                    closeButtonText={"Cancel"}
                                    onCloseCallback={closeFullSSNDialogComponent}
                                    openAsDialog={true}
                                    submitButtonText={"Submit"}
                                    onSubmitCallback={submitFullSSNDialogComponent}
                                    displaySSNInputNumber={false}
                                    dobRequired={isDobRequired}
                                    addressRequired={isAddressRequired}
                                    csidUserStatus={csidUserStatus}
                                    dispalyAdditionalHeaderMessage={false}
                                    ignoreCSIDSubmission={true}
                                />
                            }
                        </DialogComponent>
                    )}

                    {showL3SecurityQuestionDialog && (
                        <DialogComponent dialogId="dialog-l3-question" title="L3 Question" closeDialog={closeL3SecurityQuestionDialogComponent}  hideCloseButton={true}>
                            <L3SecurityQuestionComponent
                                closeButtonText={tLang("dashboard.creditScore.l3SecurityQuestionComp.cancelButtonText")}
                                onCloseCallback={closeL3SecurityQuestionDialogComponent}
                                openAsDialog={true}
                                submitButtonText={tLang("dashboard.creditScore.l3SecurityQuestionComp.submitButtonText")}
                                onSubmitCallback={submitL3SecurityQuestionDialogComponentForTu}
                                errorCallback={getL3QuestionErrorCallBackForTu}
                                ssn={ssn}
                                dob={dob}
                                address={address}
                                postponeActivation={false}
                                prepareForIDFL3={true}
                                displayTimerForTimeout={true}
                                timesInSecondBeforeTimeout={120}
                                onTimeoutCallback={l3SecurityQuestionDialogTimeOut}
                                currentTryCount={l3SecurityQuestionTryCount}
                                maxTryCount={2}
                            />
                        </DialogComponent>
                    )}
                    {showL3InvalidSsnComponent && (
                        <DialogComponent dialogId="dialog-l3-invalid-ssn-component" title="L3 Invalid SSN" hideCloseButton={true}>
                            <L3InvalidSsnComponent
                                closeButtonText={tLang("dashboard.creditScore.l3InvalidSSNComp.closeButtonText")}
                                onCloseButtonCallBack={l3InvalidSsnCloseCallBack}
                                retryButtonText={tLang("dashboard.creditScore.l3InvalidSSNComp.tryAgainButtonText")}
                                onRetryCallBack={l3InvalidSsnRetryCallBack}
                                invalidSsnAttemptstatus={invalidSsnAttemptStatus}
                            />
                        </DialogComponent>
                    )}

                    {showL3NotEnoughInfoComponent && (
                        <DialogComponent dialogId="dialog-l3-not-enough-info-component" title="L3 Not Enough Information" hideCloseButton={true}>
                            <L3NotEnoughInfoComponent
                                closeButtonText={tLang("dashboard.creditScore.L3NotEnoughInfoComp.closeButtonText")}
                                onCloseButtonCallBack={l3NotEnoughInfoCloseCallBack}
                                retryButtonText={tLang("dashboard.creditScore.L3NotEnoughInfoComp.tryAgainBtnText")}
                                onRetryCallBack={l3NotEnoughInfoRetryCallBack}
                                attemptStatus={noQuestionAttemptStatus}
                            />
                        </DialogComponent>
                    )}
                </React.Fragment>
            )}

            {csidUserStatus?.l3AuthProvider?.isExperian && showL3SecurityQuestionDialog && (
                <DialogComponent dialogId="dialog-l3-question" title="L3 Question" closeDialog={closeL3SecurityQuestionDialogComponent}>
                    <L3SecurityQuestionComponent
                        closeButtonText={"Cancel"}
                        onCloseCallback={closeL3SecurityQuestionDialogComponent}
                        openAsDialog={false}
                        submitButtonText={"Submit"}
                        onSubmitCallback={submitL3SecurityQuestionDialogComponent}
                        errorCallback={getL3QuestionErrorCallBack}
                        ssn={ssn}
                        dob={dob}
                        postponeActivation={false}
                        prepareForIDFL3={false}
                        displayTimerForTimeout={true}
                        timesInSecondBeforeTimeout={120}
                        onTimeoutCallback={l3SecurityQuestionDialogTimeOut}
                        currentTryCount={l3SecurityQuestionTryCount}
                        maxTryCount={2}
                    />
                </DialogComponent>
            )}
            {showL3ContinueDialogForError && (
                <DialogComponent dialogId="dialog-l3-continue-with-error" title="L3 Continue with error" hideCloseButton={true}>
                    <L3ContinueComponent
                        submitButtonText={"Try verification again"}
                        onSubmitCallback={l3ContinueWithErrorSubmitCallBack}
                        messageKey={messageKeyForL3ContinueWithError}
                        continueFlowWithL3={true}
                    />
                </DialogComponent>
            )}
            {showCallInComponent && (
                <DialogComponent dialogId="call-in-comp" title="L3 Question" closeDialog={closeL3SecurityQuestionDialogComponent} style={{ padding: "-10px" }}>
                    <L3CallInComponent
                        closeButtonText={"Close"}
                        onCloseCallback={closeCallback}
                        openAsDialog={false}
                        continueButtonText={tLang("dashboard.creditScore.l3CallInComp.finishVerification")}
                        onContinueButtonCallback={callInContinueCallBack}
                        callInReason={callInReason}
                        l3Case={"credit-service"}
                        l3Provider={csidUserStatus?.l3AuthProvider?.isExperian ? "CSID" : "TUI"}
                    />
                </DialogComponent>
            )}
            {showDisclosureDiaglog && (
                <DialogComponent dialogId="dialog-l3-disclosure" title="L3 Disclosure" closeDialog={closeDisclosureDialogCallBack} className="l3-close-icon"  hideCloseButton={true}>
                    <L3DisclosureComponent
                        closeButtonText={tLang("dashboard.creditScore.l3DisclosureComp.closeButton")}
                        onCloseCallback={closeDisclosureDialogCallBack}
                        openAsDialog={true}
                        submitButtonText={tLang("dashboard.creditScore.l3DisclosureComp.submitButton")}
                        onSubmitCallback={disclosureSubmitCallBack}
                        providerName={csidUserStatus?.l3AuthProvider?.isExperian ? "experian" : "transunion"}
                        isTuCanadianUser={isTuCanadianUser}
                    />
                </DialogComponent>
            )}
            {showL3SystemError && (
                <DialogComponent dialogId="dialog-l3-system-error" title="L3 System Error" hideCloseButton={true}>
                    <L3SystemErrorComponent
                        refreshButtonText={tLang("dashboard.creditScore.l3SystemErrorComp.refreshButtonText")}
                        onRefreshCallBack={l3SystemErrorRefreshCallBack}
                        closeButtonText={tLang("dashboard.creditScore.l3SystemErrorComp.closeButtonText")}
                        onCloseButtonCallBack={l3SystemErrorCloseCallBack}
                    />
                </DialogComponent>
            )}
            {showL3VerifiedDialog && (
                <DialogComponent dialogId="dialog-l3-complete-with-success" title="L3 complete" hideCloseButton={true}>
                    <L3SuccessComponent openAsDialog={false} continueButtonText={tLang("dashboard.creditScore.l3SuccessComp.continueButtonText")} onContinueCallback={l3SuccessComponentContinueCallBack} />
                </DialogComponent>
            )}
        </>
    );
};

export default CreditAlert;
